import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	alpha,
	Theme,
} from '@mui/material/styles';
// Import enumerations.
import {
	BreakpointWidth,
} from '@app/enumerations';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		listItem_parentContainer: {
			'&:focus': {
				outline: `1px dotted ${theme.palette.grey[500]}`,
			}
		},
		listItem_monitor: {

		},
		listItem_mobile: {
			paddingRight: theme.spacing(0),
			paddingLeft: theme.spacing(0),
			paddingTop: theme.spacing(2),
			paddingBottom: theme.spacing(2),
		},
		listItem_mobileDivider: {
			paddingRight: theme.spacing(0),
			paddingLeft: theme.spacing(0),
		},
		listItem_mobileContent: {

		},
		listItem_mobileCardContent: {
			paddingLeft: theme.spacing(2),
			paddingRight: theme.spacing(2),
			paddingTop: theme.spacing(0),
			paddingBottom: `${theme.spacing(0)}px !important`,
		},
		listItem_mobileContentIndent: {
			width: '100%',
		},
		listItem_mobileIcon: {
			color: theme.palette.info.main,
		},
		listItem_card: {
			boxShadow: `0px 2px 1px -5px ${alpha(theme.palette.common.black, .2)}, 0px 1px 10px 0px ${alpha(theme.palette.common.black, .14)}, 0px 1px 3px 0px ${alpha(theme.palette.common.black, .12)}`,
		},
		listItem_container: {
			borderRadius: theme.shape.borderRadius,
		},
		listItem_header: {
			padding: '10px 15px',
			display: 'flex',
			borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0px 0px`
		},
		listItem_headerPrimary: {
			background: theme.palette.primary.main,
			color: theme.palette.primary.contrastText,
		},
		listItem_headerSecondary: {
			background: theme.palette.secondary.main,
			color: theme.palette.secondary.contrastText,
		},
		listItem_headerError: {
			background: theme.palette.error.main,
			color: theme.palette.error.contrastText,
		},
		listItem_headerWarning: {
			background: theme.palette.warning.main,
			color: theme.palette.warning.contrastText,
		},
		listItem_headerInfo: {
			background: theme.palette.info.main,
			color: theme.palette.info.contrastText,
		},
		listItem_headerSuccess: {
			background: theme.palette.success.main,
			color: theme.palette.success.contrastText,
		},
		listItem_headerLeft: {
			flex: '1 0',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		listItem_headerRight: {
			display: 'inline-flex',
			justifyContent: 'flex-end',
			flexWrap: 'wrap',
			flex: '0 0 auto',
		},
		listItem_headerTitle: {
			display: 'flex',
			flexDirection: 'column',
			fontWeight: theme.typography.fontWeightBold as any,
			justifyContent: 'center',
		},
		listItem_headerTitleMobile: {
			fontWeight: theme.typography.fontWeightBold as any,
		},
		listItem_headerTitleBody: {
			display: 'flex',
			flexDirection: 'row',
		},
		listItem_headerTitleIcon: {
			marginRight: theme.spacing(1),
		},
		listItem_headerTitleCard: {
			color: theme.palette.info.main,
			fontSize: theme.typography.body1.fontSize,
			fontWeight: theme.typography.fontWeightBold as any,
		},
		listItem_headerSubtitle: {
			flex: '1 0',
			fontSize: theme.typography.subtitle2.fontSize,
		},
		listItem_headerSubtitleMobileDefault: {
			color: theme.palette.grey[400],
		},
		listItem_headerSubtitleMobilePrimary: {
			color: theme.palette.primary.main,
		},
		listItem_headerSubtitleMobileSecondary: {
			color: theme.palette.secondary.main,
		},
		listItem_headerSubtitleMobileError: {
			color: theme.palette.error.main,
		},
		listItem_headerSubtitleMobileWarning: {
			color: theme.palette.warning.main,
		},
		listItem_headerSubtitleMobileInfo: {
			color: theme.palette.info.main,
		},
		listItem_headerSubtitleMobileSuccess: {
			color: theme.palette.success.main,
		},
		listItem_headerSubtitleIcon: {
			fontSize: theme.typography.subtitle1.fontSize,
		},
		listItem_headerSubtitleIconContainer: {
			marginRight: '5px',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		listItem_headerSubtitleContainer: {
			marginTop: '5px',
			display: 'flex',
		},
		listItem_collapsedContentButtonWrapper: {
			display: 'inline-table',
			margin: 'auto',
			position: 'absolute',
			top: '25%',
			bottom: '25%',
			left: 0,
			right: 0,
		},
		listItem_collapsedContentButton: {
			width: '100px',
			padding: theme.spacing(0, 0, 1.5, 0),
			borderRadius: theme.shape.borderRadius,
			fontWeight: theme.typography.fontWeightBold,
			boxShadow: 'none',
			cursor: 'pointer',
			fontSize: '1.7em',
			whiteSpace: 'nowrap',
			justifyContent: 'center',
			'&:hover': {
				boxShadow: 'none',
				backgroundColor: theme.palette.grey[300],
				transition: `300ms ease-in-out`,
			},
			transition: `300ms ease-in-out`,
			backgroundColor: theme.palette.grey[200],
			color: theme.palette.grey[500],
			lineHeight: '.25',

		},
		listItem_body: {
			padding: '20px 15px',
			borderRadius: `0px 0px ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px`,
			position: 'relative',
		},
		listItem_bodyPrimary: {
			border: `1px solid ${theme.palette.primary.main}`,
		},
		listItem_bodySecondary: {
			border: `1px solid ${theme.palette.secondary.main}`,
		},
		listItem_bodyError: {
			border: `1px solid ${theme.palette.error.main}`,
		},
		listItem_bodyWarning: {
			border: `1px solid ${theme.palette.warning.main}`,
		},
		listItem_bodyInfo: {
			border: `1px solid ${theme.palette.info.main}`,
		},
		listItem_bodySuccess: {
			border: `1px solid ${theme.palette.success.main}`,
		},
		listItem_iconButtonPrimary: {
			color: theme.palette.primary.contrastText
		},
		listItem_iconButtonSecondary: {
			color: theme.palette.secondary.contrastText
		},
		listItem_iconButtonError: {
			color: theme.palette.error.contrastText
		},
		listItem_iconButtonWarning: {
			color: theme.palette.warning.contrastText
		},
		listItem_iconButtonInfo: {
			color: theme.palette.info.contrastText
		},
		listItem_iconButtonSuccess: {
			color: theme.palette.success.contrastText
		},
		listItem_menu: {
			zIndex: `${theme.zIndex.tooltip} !important` as any,
		},
		listItem_subtitleButtonWrapper: {
			display: 'flex',
		},
		listItem_slashDivider: {
			margin: theme.spacing(0, .5),
		},
		listItem_subtitleButton: {
			padding: '0px',
			backgroundColor: 'transparent',
			boxShadow: 'none',
			cursor: 'pointer',
			minWidth: 'unset',
			borderRadius: '0px',
			textTransform: 'capitalize',
			'&:hover': {
				backgroundColor: 'transparent',
				boxShadow: 'none',
				transition: `${theme.transitions.duration.standard}ms ease-in-out`,
				textDecoration: 'underline',
			},
			color: 'inherit',
			transition: `${theme.transitions.duration.standard}ms ease-in-out`,
			whiteSpace: 'nowrap',
			justifyContent: 'flex-start',
		},
	});
});

export default useStyles;
